import { ROUTE_NAMES } from './routeNames.const'

export const routeInspect = {
  path: '/inspect/:url(.*)',
  props: true,
  name: ROUTE_NAMES.inspect,
  component: () =>
    import(/* webpackChunkName: "Budget" */ 'src/pages/inspect/inspect.vue'),
}
